import React, {Component, Fragment} from 'react';
import {createLoadingSelector} from "../../../selectors";
import {
    clearPaymentFormData,
    getPaymentFormData,
    getPaymentStatus,
    clearPaymentStatus,
    paymentByToken
} from "../../../actions/payment.actions";
import {
    getAutoPayAvailableCC,
} from '../../../actions/homeInfoActions'
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import {getPayment} from "../../../selectors";
import isEmpty from "../../../utils/helpers";

class PaymentFormComponent extends Component {

    state = {
        paymentFormSubmitted: false,
        submitFormData: false,
    }

    componentDidMount() {
        this.referenceId = '';
        this.xBtnTimeoutHandle = setTimeout(() => {
            this.props.togglePreventPanelClosing(false);
            window.removeEventListener('beforeunload', this.preventTabClose);
        }, 40000);
    }

    componentWillUnmount() {
        this.props.clearPaymentFormData();
        this.props.clearPaymentStatus();

        if (this.xBtnTimeoutHandle) {
            clearTimeout(this.xBtnTimeoutHandle);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            getPaymentStatus,
            paymentStatus,
            handlePaymentSuccess,
            handlePaymentFail,
            handlePaymentGeneric,
            getAutoPayAvailableCC
        } = this.props;

        if (this.state.submitFormData && !isEmpty(this.props.formData)) {
            this.paymentForm.submit();
            this.setState({paymentFormSubmitted: true, submitFormData: false});
            getPaymentStatus(this.referenceId);
        }

        if (!isEmpty(this.props.formData) && prevProps.formData !== this.props.formData) {
            this.referenceId = this.props.formData.fields['ReferenceId'];
        }

        if (prevProps.paymentStatusCount !== this.props.paymentStatusCount) {
            if (paymentStatus.inProgress === true) {
                getPaymentStatus(this.referenceId);
            } else {
                this.setState({paymentFormSubmitted: false});

                this.props.togglePreventPanelClosing(false);

                window.removeEventListener('beforeunload', this.preventTabClose);

                if (paymentStatus.status === 'FAIL') {
                    handlePaymentFail(paymentStatus);
                }
                else if (paymentStatus.status === 'SUCCESS') {
                    handlePaymentSuccess(paymentStatus);
                    getAutoPayAvailableCC(this.props.accountId);
                }
                else if (paymentStatus.status === 'USED') {
                    handlePaymentSuccess(paymentStatus);
                    getAutoPayAvailableCC(this.props.accountId);
                }
                else {
                    handlePaymentGeneric(paymentStatus);
                    getAutoPayAvailableCC(this.props.accountId);
                }
            }
        }
    }


    submitPaymentForm = (data) => {

        const {accountInfo, getPaymentFormData, handlePaymentFail} = this.props;
        this.setState({paymentFormSubmitted: true})
        this.props.togglePreventPanelClosing(true);
        window.addEventListener('beforeunload', this.preventTabClose);

        getPaymentFormData(data.accountId || this.props.accountId, data).then(resp => {
            this.setState({paymentFormSubmitted: false})
            if (resp.data && resp.data.fields) {
                this.setState({submitFormData: true});
                return;
            }
            handlePaymentFail({status: 'FAILED', responseText: "Invalid data"});
        }).catch(error => {
            console.error('Error getting payment form data:', error);
            handlePaymentFail({status: 'FAILED', responseText: "Error getting payment form data"});
        });
    }

    submitPaymentWithToken = (data) => {
        const {accountInfo, handlePaymentSuccess, handlePaymentFail, paymentByToken, handlePaymentGeneric} = this.props;
        this.setState({paymentFormSubmitted: true})
        this.props.togglePreventPanelClosing(true);
        window.addEventListener('beforeunload', this.preventTabClose);

        paymentByToken(data.accountId || this.props.accountId, data).then(resp => {
            this.setState({paymentFormSubmitted: false})
            if (resp.success) {
                this.setState({submitFormData: false, paymentFormSubmitted: false});
                if (resp.inProgress === true) {
                } else if (resp.status === 'SUCCESS' || resp.status === 'USED') {
                    this.props.togglePreventPanelClosing(false);
                    handlePaymentSuccess({status: resp.status, result:resp});
                } else if (resp.status === 'FAIL') {
                    this.props.togglePreventPanelClosing(false);
                    handlePaymentFail({status: 'FAILED', responseText: "Transaction Failed", result:resp});
                } else {
                    this.props.togglePreventPanelClosing(false);
                    handlePaymentGeneric(resp.status);
                }
                return;
            }
            this.props.togglePreventPanelClosing(false);
            handlePaymentFail({status: 'FAILED', responseText: "Invalid data"});
        }).catch(error => {
            this.props.togglePreventPanelClosing(false);
            handlePaymentFail({status: 'FAILED', responseText: "Error submitting payment"});
        });
    }


    preventTabClose = () => {
        if (this.props.paymentStatus === null) {

            let e = window.event;
            if (e) e.returnValue = true;
            return true;
        }
    }

    render() {
        const {loading, formData} = this.props;
        const formTarget = this.props.formTarget || (formData && formData.target);

        // if (loading === true || this.state.paymentFormSubmitted === true) {
        //     return (
        //         <>
        //             <Loader />
        //             <br/>
        //         </>
        //     );
        // }

        if (isEmpty(formData)) {
            return null;
        }

        return (
            <Fragment>
                <div className="cmv-container-customer-pmnt-card">
                    <form method="post" ref={(ref) => {this.paymentForm = ref}} action={formData.action} target={formTarget}>
                        {Object.keys(formData.fields).map((key) => (
                            <input key={key} type="hidden" name={key} value={formData.fields[key]} />
                        ))}
                    </form>
                </div>
            </Fragment>
        );
    }
}

PaymentFormComponent.propTypes = {
    accountId: PropTypes.object.isRequired,
    formTarget: PropTypes.string,
    handlePaymentSuccess: PropTypes.func,
    handlePaymentFail: PropTypes.func,
    handlePaymentGeneric: PropTypes.func,
};
const getFormDataSelector = createLoadingSelector(['GET_PAYMENT_FORM']);

const mapStateToProps = (state) => {
    const loading = getFormDataSelector(state),
        formData = getPayment(state).formData,
        paymentStatus = getPayment(state).paymentStatus,
        paymentStatusCount = getPayment(state).paymentStatusCount;

    return {
        loading,
        formData,
        paymentStatus,
        paymentStatusCount
    };
};

const mapDispatchToProps = {
    getPaymentFormData,
    clearPaymentFormData,
    getPaymentStatus,
    clearPaymentStatus,
    getAutoPayAvailableCC,
    paymentByToken,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(PaymentFormComponent);

